import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["username", "domain", "hidden"]

  connect() {
    // Initialize the hidden field on page load
    this.updateEmail()
  }

  updateEmail() {
    const username = this.usernameTarget.value.trim()
    const domain = this.domainTarget.value

    if (username && domain) {
      this.hiddenTarget.value = `${username}@${domain}`
    } else if (username) {
      // If only username, still set it (might be editing)
      this.hiddenTarget.value = username
    } else {
      this.hiddenTarget.value = ""
    }
  }
}
